<template>
    <form @submit.prevent="handleSubmit" class="form-register">
      <div class="mb-3">
        <input type="text" class="form-control input-estilo" placeholder="Nombres" v-model="form.nombres" required />
      </div>
      <div class="mb-3">
        <input type="text" class="form-control input-estilo" placeholder="Apellidos" v-model="form.apellidos" required />
      </div>
      <div class="mb-3">
        <input type="text" class="form-control input-estilo" placeholder="Ciudad" v-model="form.ciudad" required />
      </div>
      <button class="btn btn-mondelez w-100" type="submit" :disabled="loading">{{ loading ? 'Enviando...' : 'Registrarme' }}</button>
    </form>
</template>

<script setup>
import { reactive, ref } from 'vue';
import { registerUser } from '../services/authService';
import { useRouter } from 'vue-router';
import Swal from 'sweetalert2';

const form = reactive({ nombres: '', apellidos: '', ciudad: '' });
const loading = ref(false);
const router = useRouter();

const handleSubmit = async () => {
  if (loading.value) return;
  loading.value = true;

  Swal.fire({
    title: 'Registrando...',
    text: 'Por favor espera un momento.',
    allowOutsideClick: false,
    didOpen: () => {
      Swal.showLoading();
    }
  });

  try {
    const data = await registerUser(form);

    Swal.close();

    localStorage.setItem('token', data.token);
    localStorage.setItem('usuario', JSON.stringify(data.usuario));
    router.push('/home');
  } catch (err) {
    Swal.close();
    Swal.fire('Error', err.response?.data?.msg || 'Error al registrar', 'error');
  } finally {
    loading.value = false;
  }
};
</script>

<style scoped>
.form-register {
  font-family: Arial, Helvetica, sans-serif;
}

.input-estilo {
  border-radius: 12px;
  border: 2px solid #ccc;
  padding: 0.75rem;
  font-size: 1.1rem;
  font-family: Arial, Helvetica, sans-serif;
  transition: border-color 0.3s, box-shadow 0.3s;
}

.input-estilo:focus {
  border-color: #4B0082;
  box-shadow: 0 0 0 0.2rem rgba(75, 0, 130, 0.15);
  outline: none;
}

.btn-mondelez {
  background-color: #4B0082;
  color: #fff;
  font-weight: bold;
  font-size: 1.2rem;
  padding: 0.8rem;
  border-radius: 12px;
  border: none;
  font-family: Arial, Helvetica, sans-serif;
  transition: background-color 0.3s;
}

.btn-mondelez:hover {
  background-color: rgb(118, 78, 151);
  color: #fff;
}
</style>